import React from "react";
import { useSelector } from "react-redux";
import SportTabination from "./sportTabination";
import SportsFilter from "../../components/sportsFilter";
import { styleObjectGetBG } from "../../common/StyleSeter";
import SportsBanner from "./SportsBanner";
import HomePromoSlider from "./HomePromoSlider";

interface SportsHeaderProps {
  activeSport: string;
  sportDetails?: any;
  setSportDetails?: any;
  setactiveClassForsport?: any;
  setTurnamentName?: any;
  showFilter?: boolean;
  showTitle?: boolean;
  highlightsStyle?: React.CSSProperties;
  highlightsClassName?: string;
}

const SportsHeader: React.FC<SportsHeaderProps> = ({
  activeSport,
  sportDetails,
  setSportDetails,
  setactiveClassForsport,
  setTurnamentName,
  showFilter = true,
  highlightsStyle,
  highlightsClassName = "yellow-bg2 text-color-black2 highligths-txt",
  showTitle = true,
}) => {
  const DD = useSelector((e: any) => e.domainDetails);

  return (
    <>
      {DD?.sportsSlider === true && <HomePromoSlider />}
      <SportsBanner />
      <div className="highlightLabel">
        <div className="wrap-highlight ">
          <a className="a-search" href="">
            Search
          </a>
          <SportTabination activeClass={activeSport} />
        </div>
      </div>
      {showTitle && (
        <h3
          style={highlightsStyle || styleObjectGetBG(DD?.colorSchema, false, true)}
          className={highlightsClassName}
        >
          Sports Highlights
        </h3>
      )}
      {showFilter && sportDetails && setSportDetails && (
        <SportsFilter
          sportDetails={sportDetails}
          setSportDetails={setSportDetails}
          setactiveClassForsport={setactiveClassForsport}
          setTurnamentName={setTurnamentName}
        />
      )}
    </>
  );
};

export default SportsHeader;
